import {
    BASE_URL,
    GET,
    RESET_PASSWORD
  } from "../constants";
  import { statusParsing, jsonParsing } from "../utils";
  import {getAccessToken} from "../../authActions/authActions";
  
  export const resetPassword = async(emailAddress) => {
    const token = await getAccessToken();
    const _emailAddress=emailAddress?.toLowerCase()
    let resource=`${BASE_URL}${RESET_PASSWORD}?email=${_emailAddress}`;  
    return fetch(resource, {
      method: GET,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `Bearer ${token}`
      }
    })
    .then(statusParsing)
    .then(jsonParsing);
  };

  
  